import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const MySwal = withReactContent(Swal2);

const SellSystemDashboard = (props) => {
  const [showStatistics, setShowStatistics] = useState(false);
  const [loading, setLoading] = useState(true);
  const [s1, setS1] = useState([]);
  const [s2, setS2] = useState([]);
  const [s3, setS3] = useState([]);
  const [s4, setS4] = useState([]);
  const [s5, setS5] = useState([]);
  const [s6, setS6] = useState([]);
  const [s7, setS7] = useState([]);
  const [s8, setS8] = useState([]);
  const [sellTaskType, setSellTaskType] = useState([]);
  const [task, setTask] = useState("all");
  const [type, setType] = useState("all");
  const [from, setFrom] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [to, setTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );

  const [addFrom, setAddFrom] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [addTo, setAddTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );

  const fetchS1 = async () => {
    var body = {
      from: from,
      to: to,
      task: task,
      type: type,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getS1Data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setS1(data);
        fetchS2();
      })
      .catch((error) => {});
  };

  const fetchS2 = async () => {
    var body = {
      from: from,
      to: to,
      type: type,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getS2Data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setS2(data);
        fetchS3();
      })
      .catch((error) => {});
  };

  const fetchS3 = async () => {
    var body = {
      from: from,
      to: to,
      type: type,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getS3Data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setS3(data);
        fetchS4();
      })
      .catch((error) => {});
  };

  const fetchS4 = async () => {
    var body = {
      from: from,
      to: to,
      type: type,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getS4Data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setS4(data);
        fetchTaskType();
      })
      .catch((error) => {});
  };

  const fetchTaskType = async () => {
    var body = {
      from: from,
      to: to,
      task: task,
      type: type,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellTaskType", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSellTaskType(data);
        fetchS5();
      })
      .catch((error) => {});
  };

  const fetchS5 = async () => {
    var body = {
      from: from,
      to: to,
      task: task,
      type: type,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getS5Data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setS5(data);
        fetchS6();
      })
      .catch((error) => {});
  };

  const fetchS6 = async () => {
    var body = {
      from: from,
      to: to,
      task: task,
      type: type,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getS6Data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setS6(data);
        fetchS7();
      })
      .catch((error) => {});
  };

  const fetchS7 = async () => {
    var body = {
      from: from,
      to: to,
      type: type,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getS7Data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setS7(data);
        fetchS8();
      })
      .catch((error) => {});
  };

  const fetchS8 = async () => {
    var body = {
      from: from,
      to: to,
      type: type,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getS8Data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setS8(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchS1();
  };

  useEffect(() => {
    getData();
  }, []);

  const createExcelDS = () => {
    var tab = [];
    tab.push(["Pracownik", "Zadanie", "Status", "Data realizacji"]);
    s5.map((el) => {
      tab.push([el.responsible, el.task, el.status, el.finalDate]);
    });
    return tab;
  };

  const exportToExcel = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelDS());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const desktopFilters = (
    <>
      <div
        className="paymentMenuContainer"
        style={{ marginTop: "2vh", alignItems: "baseline" }}
      >
        <div
          style={{
            marginTop: "0",
            marginBottom: "5vh",
            width: "30%",
          }}
        >
          <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
            Zakres dat
          </label>
          <div style={{ marginTop: "5px" }} className="inputBox">
            <div
              style={{ width: "45%", minWidth: "auto" }}
              className="inputCol_2"
            >
              <label style={{ fontSize: ".8vw" }}>Od</label>
              <input
                style={{ height: "3vh" }}
                type="date"
                id="name"
                name="name"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              />
            </div>
            <div
              style={{ width: "45%", minWidth: "auto" }}
              className="inputCol_2"
            >
              <label style={{ fontSize: ".8vw" }}>Do</label>
              <input
                style={{ height: "3vh" }}
                type="date"
                id="name"
                name="name"
                value={to}
                onChange={(e) => {
                  setTo(e.target.value);
                }}
              />
            </div>
          </div>
          <div style={{ marginTop: "2vh" }}>
            <button
              style={{
                backgroundColor: "#00bdce",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
              }}
              id="clientsFilterButton"
              className="paymentMenuButton"
              onClick={getData}
            >
              Pokaż
            </button>
          </div>
        </div>
        <div style={{ width: "15%" }}>
          <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
            Rodzaj spraw
          </label>
          <div style={{ marginTop: "5px" }} className="inputBox">
            <div
              style={{ width: "100%", minWidth: "auto" }}
              className="inputCol_1"
            >
              <label style={{ fontSize: ".8vw" }}>TYP</label>
              <select
                style={{ height: "3vh" }}
                type="date"
                id="name"
                name="name"
                value={type}
                onChange={(e) => {
                  setType(e.target.value);
                }}
              >
                <option key={0} value="all">
                  Wszystkie
                </option>
                <option key={1} value="chf">
                  CHF
                </option>
                <option key={2} value="skd">
                  SKD
                </option>
                <option key={2} value="wibor">
                  WIBOR
                </option>
              </select>
              <div style={{ marginTop: "2vh" }}>
                <button
                  style={{
                    backgroundColor: "#00bdce",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "15px",
                  }}
                  id="clientsFilterButton"
                  className="paymentMenuButton"
                  onClick={getData}
                >
                  Pokaż
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const mobileFilters = (
    <>
      <div className="paymentMenuContainer" style={{ marginTop: "2vh" }}>
        <div
          style={{
            marginTop: "0",
            marginBottom: "5vh",
            width: "100%",
          }}
        >
          <label style={{ fontSize: "3vw", fontWeight: "600" }}>
            Zakres dat
          </label>
          <div style={{ marginTop: "5px" }} className="inputBox">
            <div
              style={{ width: "45%", minWidth: "auto" }}
              className="inputCol_2"
            >
              <label style={{ fontSize: "3vw" }}>Od</label>
              <input
                style={{ height: "3vh" }}
                type="date"
                id="name"
                name="name"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              />
            </div>
            <div
              style={{ width: "45%", minWidth: "auto" }}
              className="inputCol_2"
            >
              <label style={{ fontSize: "3vw" }}>Do</label>
              <input
                style={{ height: "3vh" }}
                type="date"
                id="name"
                name="name"
                value={to}
                onChange={(e) => {
                  setTo(e.target.value);
                }}
              />
            </div>
          </div>
          <div style={{ marginTop: "2vh" }}>
            <button
              style={{
                backgroundColor: "#00bdce",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
              }}
              id="clientsFilterButton"
              className="paymentMenuButton"
              onClick={getData}
            >
              Pokaż
            </button>
          </div>
        </div>
        <div style={{ width: "15%" }}>
          <label style={{ fontSize: "3vw", fontWeight: "600" }}>
            Rodzaj spraw
          </label>
          <div style={{ marginTop: "5px" }} className="inputBox">
            <div
              style={{ width: "100%", minWidth: "auto" }}
              className="inputCol_1"
            >
              <label style={{ fontSize: "3vw" }}>TYP</label>
              <select
                style={{ height: "3vh" }}
                type="date"
                id="name"
                name="name"
                value={type}
                onChange={(e) => {
                  setType(e.target.value);
                }}
              >
                <option key={0} value="all">
                  Wszystkie
                </option>
                <option key={1} value="chf">
                  CHF
                </option>
                <option key={2} value="skd">
                  SKD
                </option>
                <option key={2} value="wibor">
                  WIBOR
                </option>
              </select>
              <div style={{ marginTop: "2vh" }}>
                <button
                  style={{
                    backgroundColor: "#00bdce",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "15px",
                  }}
                  id="clientsFilterButton"
                  className="paymentMenuButton"
                  onClick={getData}
                >
                  Pokaż
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const handleTaskChange = (e) => {
    setTask(e.target.value);
  };

  const leadsData = (
    <>
      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw", width: "250px" }}>
          OTWARTE ZADANIA
        </p>
        <select
          style={{ boxSizing: "border-box" }}
          type="text"
          id="name"
          name="name"
          value={task}
          onChange={handleTaskChange}
        >
          <option key={"all"} value={"all"}>
            {"Wszystkie"}
          </option>
          {sellTaskType.map((el) => (
            <>
              <option key={el.name} value={el.name}>
                {el.name}
              </option>
            </>
          ))}
        </select>
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={getData}
        >
          Pokaż
        </button>
      </div>
      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
          marginBottom: "20px",
          marginTop: "20px",
        }}
      >
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={exportToExcel}
        >
          Export do EXCEL
        </button>
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Pracownik</th>
          <th>Liczba zadań - zlecone</th>
          <th>Liczba zadań - wykonane</th>
        </tr>
        <>
          {s1.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.responsible}</td>
                <td>{el2.count}</td>
                <td>{el2.count2}</td>
              </tr>
            </>
          ))}
        </>
      </table>

      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>
          POZYSKANE DOKUMENTY
        </p>{" "}
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Pracownik</th>
          <th>Liczba dokumentów</th>
        </tr>
        <>
          {s6.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.user}</td>
                <td>{el2.count}</td>
              </tr>
            </>
          ))}
        </>
      </table>

      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>WPŁYW LEADÓW</p>{" "}
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Dział</th>
          <th>Liczba leadów</th>
          <th>Liczba pozyskanych dokumentów</th>
        </tr>
        <>
          {s2.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.type}</td>
                <td>{el2.count}</td>
                <td>{el2.count1}</td>
              </tr>
            </>
          ))}
        </>
      </table>

      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>PRZYPISANE LEADY</p>{" "}
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Pracownik</th>
          <th>Ilość leadów</th>
        </tr>
        <>
          {s3.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.ownerA}</td>
                <td>{el2.count}</td>
              </tr>
            </>
          ))}
        </>
      </table>

      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>
          ILOŚĆ PODPISANYCH UMÓW
        </p>{" "}
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Pracownik</th>
          <th>Ilość umów</th>
        </tr>
        <>
          {s4.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.ownerA}</td>
                <td>{el2.count}</td>
              </tr>
            </>
          ))}
        </>
      </table>

      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>
          PRZYPISANE LEADY - AUTOMAT
        </p>
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Pracownik</th>
          <th>Ilość leadów</th>
        </tr>
        <>
          {s7.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.ownerA}</td>
                <td>{el2.count}</td>
              </tr>
            </>
          ))}
        </>
      </table>

      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>
          ILOŚĆ PODPISANYCH UMÓW - AUTOMAT
        </p>
      </div>

      <table id="statTable" style={{ width: "50%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Pracownik</th>
          <th>Ilość umów</th>
        </tr>
        <>
          {s8.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.ownerA}</td>
                <td>{el2.count}</td>
              </tr>
            </>
          ))}
        </>
      </table>
    </>
  );

  const leadsDataMobile = (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p
          style={{
            fontWeight: "600",
            fontSize: "3vw",
            width: "250px",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          OTWARTE ZADANIA
        </p>
        <select
          style={{ boxSizing: "border-box" }}
          type="text"
          id="name"
          name="name"
          value={task}
          onChange={handleTaskChange}
        >
          <option key={"all"} value={"all"}>
            {"Wszystkie"}
          </option>
          {sellTaskType.map((el) => (
            <>
              <option key={el.name} value={el.name}>
                {el.name}
              </option>
            </>
          ))}
        </select>
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={getData}
        >
          Pokaż
        </button>
      </div>
      <div
        style={{
          width: "50%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={exportToExcel}
        >
          Export do EXCEL
        </button>
      </div>

      <table id="statTable" style={{ width: "100%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Pracownik</th>
          <th>Liczba zadań - zlecone</th>
          <th>Liczba zadań - wykonane</th>
        </tr>
        <>
          {s1.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.responsible}</td>
                <td>{el2.count}</td>
                <td>{el2.count2}</td>
              </tr>
            </>
          ))}
        </>
      </table>

      <div
        style={{
          width: "100%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p
          style={{
            fontWeight: "600",
            fontSize: "3vw",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          POZYSKANE DOKUMENTY
        </p>{" "}
      </div>

      <table id="statTable" style={{ width: "100%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Pracownik</th>
          <th>Liczba dokumentów</th>
        </tr>
        <>
          {s6.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.user}</td>
                <td>{el2.count}</td>
              </tr>
            </>
          ))}
        </>
      </table>

      <div
        style={{
          width: "100%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p
          style={{
            fontWeight: "600",
            fontSize: "3vw",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          WPŁYW LEADÓW
        </p>{" "}
      </div>

      <table id="statTable" style={{ width: "100%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Dział</th>
          <th>Liczba leadów</th>
          <th>Liczba pozyskanych dokumentów</th>
        </tr>
        <>
          {s2.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.type}</td>
                <td>{el2.count}</td>
                <td>{el2.count1}</td>
              </tr>
            </>
          ))}
        </>
      </table>

      <div
        style={{
          width: "100%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p
          style={{
            fontWeight: "600",
            fontSize: "3vw",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          PRZYPISANE LEADY
        </p>
      </div>

      <table id="statTable" style={{ width: "100%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Pracownik</th>
          <th>Ilość leadów</th>
        </tr>
        <>
          {s3.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.ownerA}</td>
                <td>{el2.count}</td>
              </tr>
            </>
          ))}
        </>
      </table>

      <div
        style={{
          width: "100%",
          display: "flex",
          gap: "20px",
          alignItems: "center",
        }}
      >
        <p
          style={{
            fontWeight: "600",
            fontSize: "3vw",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          ILOŚĆ PODPISANYCH UMÓW
        </p>
      </div>

      <table id="statTable" style={{ width: "100%" }} className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Pracownik</th>
          <th>Ilość umów</th>
        </tr>
        <>
          {s4.map((el2, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{el2.ownerA}</td>
                <td>{el2.count}</td>
              </tr>
            </>
          ))}
        </>
      </table>
    </>
  );

  return (
    <>
      <div id="reportC" className="mainContainerClients">
        {loading ? (
          <>
            <Loading />
          </>
        ) : (
          <>
            <>
              <div className="desktopFilters">{desktopFilters}</div>
              <div className="mobileFilters">{mobileFilters}</div>
              <div id="testScroll" className="contentBoxPayments">
                <div className="desktopFilters">{leadsData}</div>
                <div className="mobileFilters">{leadsDataMobile}</div>
              </div>
            </>
          </>
        )}
      </div>
    </>
  );
};

export default SellSystemDashboard;
